import * as React from 'react';

import { useDeviceCondition } from '../../../../hooks';
import { AnimationElement } from '../../../common/Animation';

import * as styles from './MessageWrapper.css';

interface IMessageWrapperProps {
  children: React.ReactNode;
}

export const MessageWrapper = ({ children }: IMessageWrapperProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  return (
    <AnimationElement layout className={rootStyle}>
      <AnimationElement layout="position" className={styles['children']}>
        {children}
      </AnimationElement>
    </AnimationElement>
  );
};
